var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "video",
    {
      ref: "video",
      class: _vm.videoClass,
      attrs: {
        autoplay: _vm.autoPlay,
        loop: _vm.loop,
        controls: _vm.controls,
        playsinline: "",
      },
      domProps: { muted: _vm.muted },
      on: { blur: _vm.handleBlur, focus: _vm.handleFocus },
    },
    [_c("source", { attrs: { "data-src": _vm.videoUrl, type: "video/mp4" } })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }